import initialState from '../initialState.js';
import {
    GET_ALL_INVOICES
} from '../../actions/types/invoices';

export default (state = initialState.invoices, action) => {
    switch (action.type) {
        case GET_ALL_INVOICES: {
            return {
                ...state,
                items: action.invoices
            };
        }

        default:
            return state;
    }
};